import { Injectable } from "@angular/core";
import { ReplaySubject, Subject } from "rxjs";
import { Nullable } from "../support/nullable";

@Injectable()
export class MenuService {
  currentAnimal$: ReplaySubject<Nullable<string>> = new ReplaySubject<
    Nullable<string>
  >(1);

  clearCurrentAnimal(): void {
    this.currentAnimal$.next(null);
  }

  currentAnimal(animalId: string): void {
    this.currentAnimal$.next(animalId);
  }
}
